export function popup () {
	if (document.getElementById("popup")) {
		document.addEventListener("DOMContentLoaded", function () {
			const aboutItems = document.querySelectorAll(".about-7-item");
			const popup = document.querySelector(".popup");
			const popupContent = document.querySelector(".popup-content");
			const popupClose = document.querySelector(".popup-close");
			aboutItems.forEach((item) => {
				item.addEventListener("click", () => {
					popup.classList.add("show");
					popupContent.classList.add("show");
				});
			});
			popupClose.addEventListener("click", () => {
				popup.classList.remove("show");
				popupContent.classList.remove("show");
			});
		});
	}
}